import React, { FC } from "react";
import { Form, Select } from "antd";
import Util from "../../../util/util";
import { IPaymentPageCustomAttribute } from "@app-models";

interface CustomDropdownFieldProps {
  name: string;
  attribute: IPaymentPageCustomAttribute;
  index: number;
}

const CustomDropdownField: FC<CustomDropdownFieldProps> = ({ name, attribute, index }) => {
  return (
    <div className="name-field field-title-case" style={{ marginBottom: 24 }}>
      <div className="name-field-2">
        <label className="form-label-style">{attribute.fieldName}</label>
        <Form.Item
          name={name}
          rules={[
            {
              required: attribute.mandatory,
              message: "Field is mandatory",
            },
          ]}
          style={{ marginBottom: 0 }}
        >
          <Select
            options={Util.getSelectOptionList(attribute.validationValue)}
            data-testid="custom-dropdown"
          />
        </Form.Item>
      </div>
    </div>
  );
};

export default CustomDropdownField;
